import { FC } from 'react';

type Props = {
	className?: string;
};

const UserIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M15.4173 16.6667V14.9754C15.4173 13.9402 14.9512 12.925 14.0092 12.4956C12.8602 11.9718 11.4822 11.6667 10.0007 11.6667C8.51907 11.6667 7.14107 11.9718 5.99205 12.4956C5.05004 12.925 4.58398 13.9402 4.58398 14.9754V16.6667'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10.0007 9.16658C11.6115 9.16658 12.9173 7.86075 12.9173 6.24992C12.9173 4.63909 11.6115 3.33325 10.0007 3.33325C8.38982 3.33325 7.08398 4.63909 7.08398 6.24992C7.08398 7.86075 8.38982 9.16658 10.0007 9.16658Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default UserIcon;
